(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-parllax"] && !Shopify.designMode) return;
  try {
    
  // Optional small enhancement: if the anchor contains a video and the video is clicked (not controls),
  // navigate to the link only when click originates from the video element itself.
  // This keeps native play/pause behavior intact for most browsers.
  (function() {
    try {
      var containers = document.querySelectorAll('.video-container .video-link');
      containers.forEach(function(link) {
        var video = link.querySelector('video');
        if (!video) return;

        // If controls are disabled we want the overlay to handle clicks, nothing needed here.
        // But if controls are enabled we avoid hijacking clicks that land on built-in controls.
        video.addEventListener('click', function(event) {
          // If controls are visible the user likely expects play/pause; don't navigate then.
          // We'll only navigate when controls are not enabled on the video element.
          if (video.hasAttribute('controls')) {
            return;
          }
          // Otherwise follow the link
          var href = link.getAttribute('href');
          if (href) {
            window.location.href = href;
          }
        });
      });
    } catch (e) {
      // fail silently — nothing critical
      console.error(e);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
